import { combineReducers } from 'redux';
import search from './search';

const reducer = combineReducers({
  search,
});

export default reducer;
